import React from 'react';
import FENavbar from './components/FENavbar';
import FEHero from './components/FEHero';
import FEFeatures from './components/FEFeatures';
import FEPricing, { plans } from './components/FEPricing';
import FEFaq, { faqs } from './components/FEFaq';
import FEClients from './components/FEClients';
import FEFooter from './components/FEFooter';
import Seo from '../../seo/Seo';
import { breadcrumbSchema, faqSchema, softwareApplicationSchema, webPageSchema } from '../../seo/schemas';
import './facturacion.css';

const PATH = '/facturacion-electronica';
const TITLE = 'Software de facturación electrónica DGII (e-CF) y contabilidad';
const DESCRIPTION =
    'Software de facturación electrónica y contabilidad para República Dominicana: emite comprobantes fiscales electrónicos (e-CF) validados por la DGII, reportes 606/607/608, POS y CRM. Planes desde RD$990/mes. Solicite una demo.';

const FacturacionPage = () => {
    return (
        <div className="facturacion-page">
            <Seo
                title={TITLE}
                description={DESCRIPTION}
                path={PATH}
                type="product"
                jsonLd={[
                    webPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION }),
                    softwareApplicationSchema({
                        path: PATH,
                        name: 'Coralan Facturación Electrónica + Contabilidad',
                        description: DESCRIPTION,
                        plans,
                    }),
                    faqSchema(faqs),
                    breadcrumbSchema([
                        { name: 'Inicio', path: '/' },
                        { name: 'Facturación Electrónica', path: PATH },
                    ]),
                ]}
            />
            <FENavbar />
            <FEHero />
            <FEFeatures />
            <FEPricing />
            <FEFaq />
            <FEClients />
            <FEFooter />
        </div>
    );
};

export default FacturacionPage;
